import './ArtificialIntelligence.css';

const ArtificialIntelligence = () => {

  return (
    <section className='AI-container container' id='AI'>
      <img
        src='/img/sparkle-ai-white.png'
        alt='sparkle-ai'
        className='AI-sparkle-icon'
        width="80"
        height="80"
      />
      <h1 className='AI-container-h1'>
        Llama con <span className='lancaster-color'>Inteligencia Artificial</span>
      </h1>
      <h2 className='AI-container-h2'>
        No gastes en sueldos, platícame de tu negocio.
      </h2>
      <a
        href='/'
        className='AI-try-button'
      >
        ¡Me Interesa!
      </a>
    </section>
  );
};

export default ArtificialIntelligence;
